/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  PutApiV1LocationCitiesId202,
  PutApiV1LocationCitiesId400,
  PutApiV1LocationCitiesId401,
  PutApiV1LocationCitiesId404,
  PutApiV1LocationCitiesId409,
  PutApiV1LocationCitiesId500,
  PutApiV1LocationCitiesIdMutationRequest,
  PutApiV1LocationCitiesIdMutationResponse,
  PutApiV1LocationCitiesIdPathParams,
} from "../../types/locationCityController/PutApiV1LocationCitiesId.ts";
import { cityViewModelSchema } from "../cityViewModelSchema.ts";
import { updateCityRequestViewModelSchema } from "../updateCityRequestViewModelSchema.ts";

export const putApiV1LocationCitiesIdPathParamsSchema = z.object({
  id: z.coerce.number().int(),
}) as unknown as ToZod<PutApiV1LocationCitiesIdPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const putApiV1LocationCitiesId202Schema = z.lazy(
  () => cityViewModelSchema,
) as unknown as ToZod<PutApiV1LocationCitiesId202>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const putApiV1LocationCitiesId400Schema =
  z.any() as unknown as ToZod<PutApiV1LocationCitiesId400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const putApiV1LocationCitiesId401Schema =
  z.any() as unknown as ToZod<PutApiV1LocationCitiesId401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const putApiV1LocationCitiesId404Schema =
  z.any() as unknown as ToZod<PutApiV1LocationCitiesId404>;

/**
 * @description (Conflict) Há um conflito com os dados existentes.
 */
export const putApiV1LocationCitiesId409Schema =
  z.any() as unknown as ToZod<PutApiV1LocationCitiesId409>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const putApiV1LocationCitiesId500Schema =
  z.any() as unknown as ToZod<PutApiV1LocationCitiesId500>;

export const putApiV1LocationCitiesIdMutationRequestSchema = z.lazy(
  () => updateCityRequestViewModelSchema,
) as unknown as ToZod<PutApiV1LocationCitiesIdMutationRequest>;

export const putApiV1LocationCitiesIdMutationResponseSchema = z.lazy(
  () => putApiV1LocationCitiesId202Schema,
) as unknown as ToZod<PutApiV1LocationCitiesIdMutationResponse>;
